import { render, staticRenderFns } from "./newExport.vue?vue&type=template&id=923208d4&scoped=true"
import script from "./newExport.vue?vue&type=script&lang=js"
export * from "./newExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "923208d4",
  null
  
)

export default component.exports